<!--
  Shared "GOSHAWK" wordmark — the pre-auth identity shared by the install
  wizard (`Installer/InstallWizard.vue`) and the auth-family screens
  (login / forgot-password / reset-password, injected via the
  `ComponentWrapper.vue` override in `structure/`). Extracted here so both
  places render byte-identical markup instead of duplicating the inline SVG.

  Renamed from "DAEDALUS" per Plan 006 (Platform Rename); tracking (0.08em,
  7 letters) and the trimmed viewBox come from `design/platform-brand.md`
  §1's length-scaled tracking table. The glyph is name-independent per the
  brand doc and is unchanged.

  Colours are literal hex (not `var(--theme-*)`) to match the existing
  wizard precedent: CSS custom properties don't reliably resolve inside SVG
  fills the way they do for regular DOM text, and the wizard already shipped
  hardcoded hex here, so this keeps both call sites visually identical
  rather than introducing a second, subtly-different way of doing it.
-->
<template>
  <div class="wordmark">
    <svg viewBox="0 0 430 107" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Goshawk">
      <rect x="18" y="35" width="38" height="38" rx="4" fill="#C4693B" transform="rotate(45 37 54)" />
      <rect x="30" y="47" width="14" height="14" rx="2" fill="#0E2E30" transform="rotate(45 37 54)" />
      <text
        x="86" y="68"
        font-family="system-ui, -apple-system, 'Segoe UI', sans-serif"
        font-size="42" font-weight="600" letter-spacing="3.36" fill="#FFFFFF"
      >GOSHAWK</text>
    </svg>
  </div>
</template>

<script setup>
</script>

<style lang="scss">
.wordmark {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 36px;
  flex-shrink: 0;

  svg {
    height: 22px;
    width: auto;
    display: block;
  }
}
</style>
